import styled from "styled-components";
import { Portal } from "../StandardUserInterface/Portal";
import { useViewState } from "../Context";
import { WorkflowPanelPortalId } from "./WorkflowPanel";
import { jsx as _jsx } from "react/jsx-runtime";
const WorkflowPanelPortal = _ref => {
  let {
    show
  } = _ref;
  const viewState = useViewState();
  return /*#__PURE__*/_jsx(Container, {
    show: show,
    onTransitionEnd: () => viewState.triggerResizeEvent(),
    children: /*#__PURE__*/_jsx(Portal, {
      id: WorkflowPanelPortalId
    })
  });
};
const Container = styled.div.withConfig({
  displayName: "WorkflowPanelPortal__Container",
  componentId: "sc-rgmmgo-0"
})(["width:", "px;max-width:", "px;position:absolute;left:", "px;top:", "px;max-height:calc(100% - 2 * ", "px);z-index:100;background:", ";backdrop-filter:", ";transition:all 0.25s;transition-timing-function:cubic-bezier(0.4,0,0.2,1);visibility:", ";margin-left:", ";opacity:", ";border-radius:", ";"], p => p.theme.workflowPanelWidth, p => p.theme.workflowPanelWidth, p => p.theme.workbenchMargin, p => p.theme.workbenchMargin, p => p.theme.workbenchMargin, p => p.theme.transparentDark, p => p.theme.blur, p => p.show ? "visible" : "hidden", p => p.show ? "0px" : "-".concat(p.theme.workflowPanelWidth, "px"), p => p.show ? 1 : 0, p => p.theme.radiusXL);
export default WorkflowPanelPortal;